import { Box } from '@chakra-ui/react';
import { ViewFile } from '@/components/ats';
import { resolveAgentforgeHref } from '../../../helpers/agentforgeHref';
import type { DownloadBlockData } from '../../../types';

interface DownloadBlockProps {
  data: DownloadBlockData;
}

// Generated-artifact download card (report PDF / interactive HTML), rendered
// through the shared ATS ViewFile so it looks and behaves like every other
// file in the product. The signed capability URL arrives in structured data —
// never re-typed by the LLM — so the link is always the exact minted URL.
export const DownloadBlock = ({ data }: DownloadBlockProps) => {
  if (!data?.url || !data?.name) return null;
  const href = resolveAgentforgeHref(data.url);

  return (
    <Box maxW="420px" data-test-id="agentforge-download-block">
      <ViewFile
        file={{ url: href, file_name: data.name, content_type: data.format }}
        showIcon
        useDirect
      />
    </Box>
  );
};
